"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _images = require("../../assets/images");

var _helper = require("./helper");

var _keyPress = _interopRequireDefault(require("../../hooks/key-press"));

var _styles = require("./styles");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Dropdown = /*#__PURE__*/_react.default.forwardRef(({
  type,
  options = [],
  value,
  titleLabel,
  onSelect,
  customOptionsView,
  isOptionsVisible,
  errorState,
  errorMessage,
  disabled,
  optionsPlacement,
  ...props
}, ref) => {
  const downPress = (0, _keyPress.default)('ArrowDown');
  const upPress = (0, _keyPress.default)('ArrowUp');
  const enterPress = (0, _keyPress.default)('Enter');
  const [cursor, setCursor] = (0, _react.useState)(-1);
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const [selectedOption, setSelectedOption] = (0, _react.useState)(value);

  const toggling = () => setIsOpen(!isOpen);

  const onOptionClicked = (value, index) => () => {
    setSelectedOption(value);
    setIsOpen(false);
    setCursor(index);
    if (typeof onSelect === 'function') onSelect(value);
  };

  (0, _react.useEffect)(() => {
    setIsOpen(isOptionsVisible);
  }, [isOptionsVisible]);
  (0, _react.useEffect)(() => {
    setSelectedOption(value);
  }, [value]);
  const clickRef = (0, _react.useRef)();
  (0, _helper.useClickOutside)(clickRef, () => {
    setIsOpen(false);
  }, isOpen);
  (0, _react.useEffect)(() => {
    if (options.length && isOpen && downPress) {
      setCursor(prevState => prevState < options.length - 1 ? prevState + 1 : prevState);
    }
  }, [downPress, isOpen, options.length]);
  (0, _react.useEffect)(() => {
    if (options.length && isOpen && upPress) {
      setCursor(prevState => prevState > 0 ? prevState - 1 : prevState);
    }
  }, [upPress, isOpen, options.length]);
  (0, _react.useEffect)(() => {
    if (options.length && enterPress && cursor > -1) {
      setSelectedOption(options[cursor]);
      setIsOpen(false);
    }
  }, [cursor, enterPress, options]);
  const ariaProps = {};
  const restProps = {};

  for (const [key, value] of Object.entries({ ...props
  })) {
    if (key.startsWith('aria')) ariaProps[key] = value;else restProps[key] = value;
  }

  return /*#__PURE__*/_react.default.createElement(_styles.StyledDropdownWrapper, _extends({
    ref: ref,
    tabIndex: 0
  }, ariaProps, {
    error: errorState,
    width: restProps.width,
    isDefault: type === 'large',
    disabled: disabled
  }), /*#__PURE__*/_react.default.createElement(_styles.DropDownContainer, _extends({}, restProps, {
    isDefault: type === 'large',
    ref: clickRef,
    disabled: disabled,
    isSelected: !(0, _lodash.isEmpty)(selectedOption) && selectedOption.name
  }), type === 'large' && /*#__PURE__*/_react.default.createElement("div", {
    className: "label-row",
    onClick: toggling
  }, /*#__PURE__*/_react.default.createElement(_styles.StyledDropdownLabel, {
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "dd-lable"
  }, titleLabel)), type === 'large' && !selectedOption && /*#__PURE__*/_react.default.createElement("div", {
    className: isOpen ? 'no-op-icon rotate180' : 'no-op-icon rotate0'
  }, /*#__PURE__*/_react.default.createElement(_images.DownArrow, null))), /*#__PURE__*/_react.default.createElement(_styles.StyledDropdownHeader, {
    className: "dropdown-header",
    onClick: toggling,
    isDefault: type === 'large',
    errorState: errorState,
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "content-wrapper"
  }, !(0, _lodash.isEmpty)(selectedOption) && selectedOption.name && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("label", {
    className: "option-label"
  }, selectedOption.name ? selectedOption.name : ''), type === 'small' && /*#__PURE__*/_react.default.createElement("div", {
    className: isOpen ? 'icon rotate180' : 'icon rotate0'
  }, /*#__PURE__*/_react.default.createElement(_images.DownArrow, null))))), isOpen && /*#__PURE__*/_react.default.createElement(_styles.DropDownListContainer, {
    isDefault: type === 'large',
    placement: optionsPlacement
  }, /*#__PURE__*/_react.default.createElement(_styles.DropDownList, {
    isDefault: type === 'large'
  }, /*#__PURE__*/_react.default.isValidElement(customOptionsView) ? customOptionsView : options.map((option, index) => /*#__PURE__*/_react.default.createElement(_styles.ListItem, {
    onClick: onOptionClicked(option, index),
    key: Math.random(),
    className: index === cursor && 'active'
  }, option.name)))), /*#__PURE__*/_react.default.createElement(_styles.StyledErrorMessage, {
    id: "dropdown-error"
  }, errorMessage && errorState && errorMessage), type === 'large' && selectedOption && /*#__PURE__*/_react.default.createElement("div", {
    className: isOpen ? 'icon rotate180' : 'icon rotate0'
  }, /*#__PURE__*/_react.default.createElement(_images.DownArrow, null))));
});

exports.Dropdown = Dropdown;
Dropdown.defaultProps = {
  type: 'large',
  isOptionsVisible: false,
  optionsPlacement: 'left'
};
Dropdown.propTypes = {
  type: _propTypes.default.oneOf(['small', 'large']),
  titleLabel: _propTypes.default.string,
  className: _propTypes.default.string,
  options: _propTypes.default.array.isRequired,
  value: _propTypes.default.object,
  onSelect: _propTypes.default.func,

  /** The Custom component for custom dropdown options*/
  customOptionsView: _propTypes.default.element,
  isOptionsVisible: _propTypes.default.bool,

  /** Error state */
  errorState: _propTypes.default.bool,

  /** Error message */
  errorMessage: _propTypes.default.string,

  /** Disabled state */
  disabled: _propTypes.default.bool,
  width: _propTypes.default.oneOfType([_propTypes.default.string]),

  /** Options dropdown position [Only applicable in small dropdown]*/
  optionsPlacement: _propTypes.default.oneOf(['left', 'right'])
};